import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import withStyles from '@mui/styles/withStyles';

import { green, amber } from '@mui/material/colors';
import { Alert } from '@mui/material';

// const variantIcon = {
//     success: CheckCircleIcon,
//     warning: WarningIcon,
//     error: ErrorIcon,
//     info: InfoIcon,
// };

// const styles1 = theme => ({
//     success: {
//         backgroundColor: green[600],
//     },
//     error: {
//         backgroundColor: theme.palette.error.dark,
//     },
//     info: {
//         backgroundColor: theme.palette.primary.dark,
//     },
//     warning: {
//         backgroundColor: amber[700],
//     },
//     icon: {
//         fontSize: 20,
//     },
//     iconVariant: {
//         opacity: 0.9,
//         marginRight: theme.spacing(1),
//     },
//     message: {
//         display: 'flex',
//         alignItems: 'center',
//     },
// });

// function MySnackbarContent(props) {
//     const { classes, className, message, onClose, variant, ...other } = props;
//     const Icon = variantIcon[variant];

//     return (
//         <SnackbarContent
//             className={classNames(classes[variant], className)}
//             aria-describedby="client-snackbar"
//             message={
//                 <span id="client-snackbar" className={classes.message}>
//                 <Icon className={classNames(classes.icon, classes.iconVariant)} />
//                 {message}
//                 </span>
//             }
//             action={[
//                 <IconButton
//                     key="close"
//                     aria-label="Close"
//                     color="inherit"
//                     className={classes.close}
//                     onClick={onClose}
//                     size="large">
//                 <CloseIcon className={classes.icon} />
//                 </IconButton>,
//             ]}
//             {...other}
//         />
//     );
// }

// MySnackbarContent.propTypes = {
//     classes: PropTypes.object.isRequired,
//     className: PropTypes.string,
//     message: PropTypes.node,
//     onClose: PropTypes.func,
//     variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
// };

// const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class Notif extends React.Component {

    render() {
        // S'assurer que variant/severity est une string valide
        const validSeverities = ['error', 'warning', 'info', 'success'];
        const severity = typeof this.props.variant === 'string' && validSeverities.includes(this.props.variant.toLowerCase())
            ? this.props.variant.toLowerCase()
            : 'info';
        
        // S'assurer que message est toujours une string
        const message = typeof this.props.message === 'string' 
            ? this.props.message 
            : (this.props.message ? String(this.props.message) : '');
        
        // S'assurer que onClose est une fonction
        const handleClose = typeof this.props.onClose === 'function' 
            ? this.props.onClose 
            : () => {};
        
        // S'assurer que open est un boolean
        const isOpen = Boolean(this.props.open);
        
        return (
            <Snackbar
                style={{marginTop : '60px'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={isOpen}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        );
    }
}


export default Notif;